import { defineMessages } from 'react-intl'

const cancellationPolicyTimelineMessages = defineMessages({
  modalTitle: {
    id: '36upQ7Iz8R4ndlEZX5H8',
    defaultMessage: 'Cancellation policy',
  },
})

export default cancellationPolicyTimelineMessages
